import { ApplePaySdkImpl } from "./core/ApplePaySdk";
import { ApplePayButtonColorEnumsObj } from "./enums/ApplePayButtonColorEnum";
import { ApplePayButtonTypeEnumsObj } from "./enums/ApplePayButtonTypeEnum";
import { ApplePayEventListenerEnumsObj } from "./enums/ApplePayEventListenerEnum";
import { ApplePayEventTypeEnumsObj } from "./enums/ApplePayEventTypeEnum";
import { addGetVersionToWindow } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
/** @internal */ var MAIN_OBJECT_NAME = "payairApplePay";
/** @internal */ var SDK_OBJECT_NAME = "applePaySdk";
var applePaySdk = new ApplePaySdkImpl();
/*
  NOTE
  Added getVersion to window always. If user uses JS file, the object will be overwritten with proper getVersion,
  otherwise if using NPM this object will stay in the window object.
*/
/** @internal */ addGetVersionToWindow(MAIN_OBJECT_NAME, SDK_OBJECT_NAME, applePaySdk.getVersion);
var payairApplePay = {
    applePaySdk: applePaySdk,
    ApplePayButtonColorEnums: ApplePayButtonColorEnumsObj,
    ApplePayButtonTypeEnums: ApplePayButtonTypeEnumsObj,
    ApplePayEventListenerEnums: ApplePayEventListenerEnumsObj,
    ApplePayEventTypeEnums: ApplePayEventTypeEnumsObj,
};
export default payairApplePay;
